// CSS-var references — resolved by the browser from the [data-theme] ancestor.
// Light: #16a34a / #d97706 / #dc2626  Dark: #22c55e / #f59e0b / #ef4444
export const STATUS_COLORS = {
  normal:   "var(--status-normal)",
  warn:     "var(--status-warn)",
  critical: "var(--status-critical)",
  na:       "var(--status-na)",
};

// CSS-var background references
export const STATUS_BG = {
  normal:   "var(--status-normal-bg)",
  warn:     "var(--status-warn-bg)",
  critical: "var(--status-critical-bg)",
  na:       "var(--status-na-bg)",
};

// Hex values for canvas drawing (canvas API cannot resolve CSS vars).
// Light status colors match the CSS vars above; dark colors are vivid to pop.
export const CANVAS_THEME = {
  light: {
    track:       "#e2e8f0",
    trackBorder: "#d1d5db",
    scaleText:   "#94a3b8",
    labelText:   "#334155",
    hubInner:    "#ffffff",
    normal:      "#16a34a",
    warn:        "#d97706",
    critical:    "#dc2626",
    na:          "#94a3b8",
  },
  dark: {
    track:       "#0b1120",
    trackBorder: "#2d3c50",
    scaleText:   "#64748b",
    labelText:   "#dbe4ef",
    hubInner:    "#111827",
    normal:      "#22c55e",
    warn:        "#f59e0b",
    critical:    "#ef4444",
    na:          "#64748b",
  },
};

export function getStatus(value, thresh) {
  if (value === null || value === undefined || !thresh) return "na";
  if (thresh.type === "BOOL") return "na";
  if (thresh.warn === 0 && thresh.fail === 0 && thresh.pass === 0) return "na";

  if (thresh.boundaryMode === "upper_limits") {
    if (thresh.fail > 0 && value > thresh.fail) return "critical";
    if (thresh.warn > 0 && value > thresh.warn) return "warn";
    return "normal";
  }

  if (thresh.boundaryMode === "normal_upper_fail_min") {
    if (thresh.fail > 0 && value >= thresh.fail) return "critical";
    if (thresh.warn > 0 && value > thresh.warn) return "warn";
    return "normal";
  }

  // Viscosity-style grade band: warn = low boundary, pass = high boundary.
  if (thresh.pass > 0 && thresh.warn > 0 && thresh.fail === 0) {
    if (value < thresh.warn) return "critical";
    if (value > thresh.pass * 1.15) return "critical";
    if (value > thresh.pass) return "warn";
    return "normal";
  }

  // Standard: higher is worse
  if (thresh.fail > 0 && value >= thresh.fail) return "critical";
  if (thresh.warn > 0 && value >= thresh.warn)  return "warn";
  return "normal";
}

export function getParticleCountSegmentThreshold(thresh, index) {
  if (thresh?.type !== "ISO_CODE") return thresh;
  const goodMax = Number(thresh.goodMax?.[index]);
  const failMin = Number(thresh.failMin?.[index]);
  if (!Number.isFinite(goodMax) || !Number.isFinite(failMin)) return null;
  return { type: "GT", pass: 0, warn: goodMax + 1, fail: failMin };
}
